import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';
import { Subject } from 'rxjs';
import {environment} from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ContentfulService {
  language = new Subject<string>();

  cdaClient = createClient({
    space: environment.contentful.space,
    environment:environment.contentful.environment,
    accessToken: environment.contentful.accessToken
  })

  async getEntry(lang: string, type: string, query?: object): Promise<Entry<any>[]> {
    const res = await this.cdaClient.getEntries(Object.assign({
      content_type: type, locale: lang
    }, query)
    ); 
    return this.processResponse(res);

  }

  private processResponse(response: any): Entry<any>[] {
    // Extract items from the response and remove 'metadata' from each entry
    const itemsWithoutMetadata = response.items.map((entry:any) => {
      delete entry.metadata;
      delete entry.sys;
      return entry;
    });
    return itemsWithoutMetadata[0].fields;
  }

  

}
